export default __webpack_public_path__ + "static/media/ic-generic-error.a68226d2.svg";